import React from 'react';

export const ImageContent = ({ formBlock }) => {
	return (
		<div>
			{formBlock.image() && (
				<img src={formBlock.image()} alt="" className="mw-100" style={{ borderRadius: '10px' }} />
			)}
		</div>
	);
};
